import { render, staticRenderFns } from "./SetNames.vue?vue&type=template&id=6ff0968c&scoped=true&"
import script from "./SetNames.vue?vue&type=script&lang=js&"
export * from "./SetNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0968c",
  null
  
)

export default component.exports